module.exports = __webpack_public_path__ + "static/omega3-6a596dd4e98cc96e0b710485bcf63907.png";